module Hereabout.UI.Components.PostCommentComponent where

import Prelude

import Control.Monad.Rec.Class (forever)
import Data.DateTime (DateTime(..), Month(..), diff, exactDate)
import Data.Enum (toEnum)
import Data.Formatter.DateTime as DT
import Data.Int (ceil)
import Data.List as L
import Data.Maybe (Maybe(..), fromJust)
import Data.Maybe as M
import Data.Time.Duration (Milliseconds(..))
import Data.Time.Duration as DUR
import Effect (Effect)
import Effect.Aff as Aff
import Effect.Aff.Class (class MonadAff)
import Effect.Class (class MonadEffect, liftEffect)
import Effect.Now (nowDateTime)
import Halogen as H
import Halogen.HTML as HH
import Halogen.HTML.Events as HE
import Halogen.HTML.Properties as HP
import Halogen.HTML.Properties.ARIA as PA
import Halogen.Subscription as HS
import Hereabout.Data.Route (Route(..))
import Hereabout.Effects (class Navigate, class SharePost, navigate, sharePost)
import Hereabout.Types (Comment(..), Event(..), Place(..), PostComment(..), User(..), Venue(..))
import Hereabout.UI.Bits (renderIcon)
import Hereabout.UI.Bulma.Classes as Bulma
import Hereabout.UI.Components.RawHTMLComponent as RawHTMLComp
import Hereabout.UI.SemanticUI.Classes as SemUI
import Partial.Unsafe (unsafePartial)
import Type.Proxy (Proxy(..))
import Web.HTML (HTMLElement)

foreign import data TipTap :: Type

foreign import _loadTipTap :: HTMLElement -> Effect TipTap


foreign import _toggleBold :: TipTap -> Effect Unit
foreign import _toggleItalic :: TipTap -> Effect Unit
foreign import _getMarkdown :: TipTap -> Effect String

data Action
  = InitComponent
  | SubmitComment

type Slot id = forall q. H.Slot q Void id

type ChildSlots =
  ( 
  )

type Input =
  { targetId :: String
  , user :: User
  }

type State = 
  { user :: User
  , tiptap :: Maybe TipTap
  , showThankYou :: Boolean
  , targetId :: String
  }

component :: forall q o m. MonadEffect m => Navigate m => SharePost m => H.Component q Input o m
component =
  H.mkComponent
    { initialState: \s -> { user : s.user, tiptap : Nothing, showThankYou : false, targetId : s.targetId }
    , render
    , eval: H.mkEval H.defaultEval { handleAction = handleAction, initialize = Just InitComponent }
    }


render :: forall m. MonadEffect m => State -> H.ComponentHTML Action ChildSlots m
render state =
  HH.div_ $ 
    [ HH.div [ HP.classes [ Bulma.box, Bulma.mb1 ] ]
      [ if state.showThankYou then
          renderThankYou
        else 
          renderMessage state.user
      ]
    ] 

tiptapRef ∷ H.RefLabel
tiptapRef = H.RefLabel "tiptap"

renderMessage :: forall m. MonadEffect m => User -> H.ComponentHTML Action ChildSlots m
renderMessage (User user) =
  HH.article [ HP.classes [ Bulma.media ] ]
    [ HH.div [ HP.classes [ Bulma.mediaLeft ] ]
      [ HH.figure [ HP.classes [ Bulma.image, Bulma.is64x64 ] ]
        [ HH.img [ HP.src user.imageUrl  ]
        ]
      ]
    , HH.div [ HP.classes [ Bulma.mediaContent ] ] $
      [ HH.div [ HP.classes [ Bulma.content ] ]
        [ HH.p_ 
          [ HH.strong [ HP.classes [ Bulma.mr3 ] ] [ HH.text user.fullName ]
          ]
        , HH.p_ 
          [ HH.div [ HP.ref tiptapRef, HP.classes [ Bulma.notification, Bulma.isLight, Bulma.hasTextBlack, Bulma.p2 ] ] []
          ]
        , HH.p_
          [ HH.button [ HP.classes [ Bulma.button, Bulma.isLink], HE.onClick $ \_ -> SubmitComment  ] [ HH.text "Post Comment" ]
          ]
        ]
      ] 
    ]

renderThankYou :: forall m. MonadEffect m =>  H.ComponentHTML Action ChildSlots m
renderThankYou =
  HH.div [ HP.classes [ Bulma.content ] ]
    [ HH.p_
      [ HH.text "Thank you for your contribution. All comments are currently pre-moderated for the safety and security of the platform. Please bear with us while we review your comment."
      ]
    ]

handleAction :: forall cs o m. MonadEffect m => Navigate m => SharePost m => Action -> H.HalogenM State Action cs o m Unit
handleAction InitComponent = do
  mttRef <- H.getHTMLElementRef $ tiptapRef
  let ttRef = unsafePartial $ fromJust mttRef
  tiptap <- liftEffect $ _loadTipTap ttRef
  H.modify_ (_ {tiptap = Just tiptap })
  pure unit
handleAction SubmitComment = do
  s <- H.get
  case s.tiptap of
    Just tt -> do
      md <- H.liftEffect $ _getMarkdown tt
      H.lift $ sharePost s.targetId $ PostComment {content : md}
      H.modify_ (_ {showThankYou = true })
    Nothing ->
      pure unit
  pure unit

